export default "__VITE_ASSET__CsnnqTT$__"